import React from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import { Helmet } from "react-helmet-async";

function AboutUs() {
  return (
    <>
      {/* NavBar */}
      <Helmet>
        <title>
          À propos de Mhiri Store | Smartphones et accessoires en Tunisie
        </title>
        <meta
          name="description"
          content="Découvrez Mhiri Store, votre boutique spécialisée en smartphones et accessoires en Tunisie : qualité, prix accessibles et service client dédié."
        />
      </Helmet>
      <NavBar page={"about"} />

      <div className="bisset-container">
        <header className="bisset-header">
          <h1>À propos de Mhiri Store</h1>
        </header>

        <section className="bisset-content">
          <img
            src="./../assets/mhiriStoreBg.png"
            alt="Accessoires pour téléphone"
            className="bisset-image"
          />

          <div className="bisset-text">
            <h2>Bienvenue chez Mhiri Store</h2>
            <p>
              Fondée en 2023, Mhiri Store est née d’une passion pour la
              technologie mobile et du désir de proposer sur le marché des
              accessoires de téléphone de haute qualité. Nous offrons une large
              gamme de produits pour smartphones, notamment des AirPods, des
              coques, des chargeurs, des kits, des supports, des protections et
              bien plus encore. Notre mission est de devenir la boutique de
              référence pour tout ce dont vous avez besoin afin d’améliorer,
              protéger et personnaliser votre expérience mobile.
            </p>
            <p>
              Que vous souhaitiez moderniser l’apparence de votre appareil ou
              prolonger sa durée de vie, Mhiri Store a l’accessoire qu’il vous
              faut. Nos produits sont conçus pour tous les types de téléphones
              et tous les utilisateurs, avec une attention particulière portée à
              la qualité, la durabilité et le prix.
            </p>
          </div>

          <div className="bisset-story">
            <h3>Notre histoire</h3>
            <p>
              Ce qui a commencé en 2023 comme une simple idée entre amis pour
              proposer des accessoires de téléphone de qualité est rapidement
              devenu bien plus grand. Nous avons constaté le besoin d’une
              boutique unique offrant un large choix d’accessoires sans
              compromis sur la qualité.
            </p>
            <p>
              À mesure que la technologie évolue, les besoins des utilisateurs
              changent aussi, et nous sommes là pour proposer les produits les
              plus récents afin d’aider chacun à rester à la pointe du monde
              mobile.
            </p>
          </div>

          <div className="bisset-mission">
            <h3>Notre mission</h3>
            <p>
              Notre mission est de fournir à nos clients des accessoires de
              téléphone de haute qualité qui améliorent leur expérience mobile.
              Nous proposons un large choix de produits adaptés à tous les
              besoins : accessoires pratiques, coques élégantes ou équipements
              spécialisés.
            </p>
            <p>
              Nous visons une expérience d’achat simple et rapide, de la
              découverte de nos produits à la réception fiable de votre
              commande. Notre service client est toujours disponible pour
              garantir votre satisfaction.
            </p>
          </div>

          <div className="bisset-values">
            <h3>Nos valeurs</h3>
            <p>
              Chez Mhiri Store, nous sommes guidés par des valeurs fondamentales
              qui orientent toutes nos actions :
            </p>
            <ul>
              <li>
                <strong>Orientation client :</strong> nos clients sont au centre
                de tout ce que nous faisons.
              </li>
              <li>
                <strong>Qualité :</strong> tous nos produits sont testés pour
                garantir durabilité et performance.
              </li>
              <li>
                <strong>Innovation :</strong> nous suivons l’évolution de la
                technologie pour proposer les accessoires les plus récents.
              </li>
              <li>
                <strong>Intégrité :</strong> nous agissons avec transparence et
                honnêteté.
              </li>
              <li>
                <strong>Plaisir :</strong> nous aimons ce que nous faisons et
                voulons offrir la meilleure expérience possible.
              </li>
            </ul>
          </div>
        </section>
      </div>

      {/* Footer */}
      <Footerr />
    </>
  );
}

export default AboutUs;
